import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { wallpaper } from '../../../assets/conf_urls.json';

@Injectable()

export class WallpaperUploadService {


  constructor(private http: HttpClient) {
  }

  getAllImages(): Observable<string[]> {
    return this.http.post<string[]>(wallpaper.wallpaperURL, {
      "event": "getWallpaperList"
    })
  }

  getImage(img: string): Observable<any> {
    return this.http.post<any>(wallpaper.wallpaperURL, {
      "event": "getWallpaperByName",
      "wallpaperName": img
    })
  }
  postJobs(unitsArr: any, imageID:string,requestedBy:string): Observable<any> {
    return this.http.post<any>(wallpaper.wallpaperURL, {
      "event": "postJobs",
      "data": unitsArr,
      "imageID": imageID,
      "requestedBy":requestedBy
    })
  }

}
